import { IConfiguration } from "../domain/configuration";
import { User } from "../domain/user";

export class SessionStorageAccessor {
  private static _configurationKey = "configurationKey";
  private static _tokenKey = "tokenKey";
  private static _userKey = "userKey";
  private static _folderGuidKey = "folderGuidKey";

  static get configuration(): IConfiguration {
    const text = sessionStorage.getItem(this._configurationKey);
    if (!text) { return null; }
    return JSON.parse(text);
  }

  static set configuration(value: IConfiguration) {
    if (!value) {
      sessionStorage.removeItem(this._configurationKey);
      return;
    }
    sessionStorage.setItem(this._configurationKey, JSON.stringify(value));
  }

  static get token(): string {
    return sessionStorage.getItem(this._tokenKey);
  }

  static set token(value: string) {
    if (!value) {
      sessionStorage.removeItem(this._tokenKey);
      return;
    }
    sessionStorage.setItem(this._tokenKey, value);
  }

  static get user(): User {
    return this.getUser(this._userKey);
  }

  static set user(value: User) {
    this.setUser(this._userKey, value);
  }

  static get folderGuid(): string {
    return sessionStorage.getItem(this._folderGuidKey);
  }

  static set folderGuid(value: string) {
    if (!value) {
      sessionStorage.removeItem(this._folderGuidKey);
      return;
    }
    sessionStorage.setItem(this._folderGuidKey, value);
  }

  private static getUser(key: string): User {
    const text = sessionStorage.getItem(key);
    if (!text) { return null; }
    const obj = JSON.parse(text);
    return new User(obj.id, obj.name);
  }

  private static setUser(key: string, value: User): void {
    if (!value) {
      sessionStorage.removeItem(key);
      return;
    }
    const text = JSON.stringify({
      id: value.id,
      name: value.name,
    });
    sessionStorage.setItem(key, text);
  }
}
